<template>
  <b-container>
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            Named Entity Recognition Tagger
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            INPUT FORM
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input" for="input-service-id">Masukkan teks:</label>
            <textarea id="input-service-id"
              class="sm-input"
              placeholder="Masukkan teks yang akan di analisa di sini..."
              v-model="inputText"
              rows="3"
            ></textarea>
          </div>
          <CCol col="12" class="form-button">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Create Tags
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow>
        <!-- <CRow>
          <div class="col-12">
            <label class="sm-input" for="input-customer-id">Customer ID</label>
            <input id="input-customer-id"
              disabled
              class="sm-input"
              :maxlength="50"
              v-model="customerId"
            >
          </div>
        </CRow>
        <CRow>
          <CCol col="12" class="item-footer mt-4">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickBack" class="btn custom leftside">
                  <span><img src=""></span>Kembali
                </router-link>
                <router-link :to="{}" @click.native="onClickSubmit" class="btn custom fif-blue-1 rightside">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow> -->
      </div>
      <CRow v-if="keywords.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <b-alert show variant="secondary">{{ inputText }}</b-alert>
        </CCol>
      </CRow>
      <CRow v-if="keywords.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            TAGGED SENTENCE
          </h4>
        </CCol>
      </CRow>
      <div v-if="keywords.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="keywords"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div>
      <!-- <Modal v-if="showOfficeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Office</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(office, index) in officeOptions"
              :key="'list-office-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickOffice(office)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{office.name}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showOfficeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal>
      <Modal v-if="showDaytimeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Tanggal Booking</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(daytime, index) in daytimeOptions"
              :key="'list-daytime-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickDaytime(daytime)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{daytime.dateDisplay}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showDaytimeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal>
      <Modal v-if="showClocktimeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Jam Booking</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(clocktime, index) in clocktimeOptions"
              :key="'list-clocktime-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickClocktime(clocktime)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{clocktime.startTime + ' - ' + clocktime.endTime}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showClocktimeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal> -->
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
            <!-- <button v-if="errorReload" class="btn-submit white" @click="onClickBack">
              Kembali
            </button>
            <button v-else class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
            <button v-if="errorReload" class="btn-submit" @click="onClickReload">
              Muat Ulang
            </button>
            <button v-else class="btn-submit" @click="onClickBack">
              Kembali
            </button>
            <button v-else class="btn-submit" @click="onClickMenu">
              Menu Utama
            </button> -->
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      // showOfficeModal: false,
      // showDaytimeModal: false,
      // showClocktimeModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputText: "",
      fields: [
          { key: 'index', label: '' },
          { key: 'word', label: 'Kata' },
          { key: 'category', label: 'Kategori' },
          { key: 'score', label: 'Probabilitas' },
      ],
      keywords: [],
      categoryMap: []
      // serviceId: "",
      // serviceName: "",
      // customerId: "",
      // contractNo: "",
      // servOfficeCode: "",
      // workDayBook: 1,
      // officeOptions: [],
      // daytimeOptions: [],
      // clocktimeOptions: [],
      // selectedOffice: {},
      // selectedDaytime: {},
      // selectedClocktime: {}
    }
  },
  methods: {
    // async getOffices(){
    //   this.isLoading = true
    //   let processUrl = "/office/get-office-iss-enabled?exist=1"
    //   await this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.officeOptions = response.data
    //       this.selectedOffice = {}
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = true
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = true
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onFocusOffice(){
    //   this.showOfficeModal = true
    // },
    // onFocusDaytime(){
    //   this.showDaytimeModal = true
    // },
    // onFocusClocktime(){
    //   this.showClocktimeModal = true
    // },
    // onClickOffice(office){
    //   this.selectedOffice = office
    //   this.isLoading = true
    //   let processUrl = "/fmc/getDayTimeFrame"
    //   processUrl += "?servOfficeCode=" + this.selectedOffice.servOfficeCode
    //   processUrl += "&bookingDate=" + moment().add(this.workDayBook, 'day').format("YYYY-MM-DD")
    //   processUrl += "&serviceId=" + this.serviceId
    //   this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.daytimeOptions = response.data.data.filter(item => item.available)
    //       this.daytimeOptions = this.daytimeOptions.map(item => {
    //         let split = item.date.split("-")
    //         let newDate = split[2] + "-" + split[1] + "-" + split[0]
    //         item.dateDisplay = moment(newDate).locale("id").format("dddd, D MMMM YYYY")
    //         return item
    //       })
    //       this.selectedDaytime = {}
    //       this.showOfficeModal = false
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = true
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = true
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onClickDaytime(daytime){
    //   this.selectedDaytime = daytime
    //   let dateSplit = this.selectedDaytime.date.split("-")
    //   this.selectedDaytime.dateFlip = dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0]
    //   this.isLoading = true
    //   let processUrl = "/fmc/getClockTimeFrame"
    //   processUrl += "?servOfficeCode=" + this.selectedOffice.servOfficeCode
    //   processUrl += "&bookingDate=" + this.selectedDaytime.dateFlip
    //   processUrl += "&serviceId=" + this.serviceId
    //   this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.clocktimeOptions = response.data.data.timeFrame.filter(item => item.slot > 0)
    //       this.selectedClocktime = {}
    //       this.showDaytimeModal = false
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = false
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = false
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onClickClocktime(clocktime){
    //   this.selectedClocktime = clocktime
    //   this.selectedClocktime.display = clocktime.startTime + ' - ' + clocktime.endTime
    //   this.showClocktimeModal = false
    // },
    // onClickBack(){
    //   this.$store.commit('set', ['contractNo', ""])
    //   this.$store.commit('set', ['servOfficeCode', ""])
    //   this.$store.commit('set', ['workDayBook', ""])
    //   // this.$router.push({ name: "Kontrak" })
    //   this.$router.push({ name: "KontrakBypass" })
    // },
    // onClickMenu(){
    //   this.$store.commit('set', ['serviceId', ""])
    //   this.$store.commit('set', ['serviceName', ""])
    //   this.$store.commit('set', ['customerId', ""])
    //   this.$store.commit('set', ['contractList', ""])
    //   this.$store.commit('set', ['contractNo', ""])
    //   this.$store.commit('set', ['servOfficeCode', ""])
    //   this.$store.commit('set', ['workDayBook', ""])
    //   this.$router.push({ name: "Menu" })
    // },
    // async onClickReload(){
    //   await this.getOffices()
    //   for(let i = 0; i < this.officeOptions.length; i++){
    //     if(this.officeOptions[i].servOfficeCode == this.servOfficeCode){
    //       this.selectedOffice = this.officeOptions[i]
    //       this.onClickOffice(this.officeOptions[i])
    //       break
    //     }
    //   }
    // },
    onClickSubmit(){
      this.isLoading = true
      let processUrl = "https://ktp.ocr.dev.inergi.id/api-ner/api/backend/ner"
      let data = {
        text: this.inputText
      }
      // let data = new FormData()
      // data.set('officeCode', this.selectedOffice.officeCode)
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          let raw = response.data.data
          let entries = []
          let isNewWord = false
          let currCategory = ""
          let currCount = 0
          let currWord = ""
          let currTotalScore = 0
          for(let i = 0; i < raw.length; i++){
            let [prefix, category] = raw[i].entity.split("-")
            // if B-prefix, start new word
            if(prefix === "B"){
              isNewWord = true
            }
            else{
              // if I-prefix, but differing category, start new word
              if(currCategory !== "" && category !== currCategory){
                isNewWord = true
              }
              // if I-prefix and same category, continue previous word
              else{
                isNewWord = false
              }
            }
            // if new word and there is a previous word, push and reset tally
            if(isNewWord && currCount > 0){
              currWord = currWord.replace(/▁/g," ").trim()
              if(currWord !== ""){
                entries.push({ word:currWord, category:this.categoryMap[currCategory], score:parseFloat(currTotalScore / currCount) })
              }
              currCategory = ""
              currCount = 0
              currWord = ""
              currTotalScore = 0
            }
            // start tally
            currCategory = category
            currCount += 1
            currWord += raw[i].word
            currTotalScore += parseFloat(raw[i].score)
          }
          // push the last keyword
          currWord = currWord.replace(/▁/g," ").trim()
          entries.push({ word:currWord, category:this.categoryMap[currCategory], score:parseFloat(currTotalScore / currCount) })
          this.keywords = entries
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
          return
        }
      })
      .catch(error => {
        if(error.response) this.errorLabel = error.response.data.reason
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  async mounted(){
    this.categoryMap['CRD'] = "Cardinal"
    this.categoryMap['DAT'] = "Date"
    this.categoryMap['EVT'] = "Event"
    this.categoryMap['FAC'] = "Facility"
    this.categoryMap['GPE'] = "Geopolitical Entity"
    this.categoryMap['LAW'] = "Law Entity (such as Undang-Undang)"
    this.categoryMap['LOC'] = "Location"
    this.categoryMap['MON'] = "Money"
    this.categoryMap['NOR'] = "Political Organization"
    this.categoryMap['ORD'] = "Ordinal"
    this.categoryMap['ORG'] = "Organization"
    this.categoryMap['PER'] = "Person"
    this.categoryMap['PRC'] = "Percent"
    this.categoryMap['PRD'] = "Product"
    this.categoryMap['QTY'] = "Quantity"
    this.categoryMap['REG'] = "Religion"
    this.categoryMap['TIM'] = "Time"
    this.categoryMap['WOA'] = "Work of Art"
    this.categoryMap['LAN'] = "Language"
    // this.serviceId = this.$store.state.serviceId
    // this.serviceName = this.$store.state.serviceName
    // this.customerId = this.$store.state.customerId
    // this.contractNo = this.$store.state.contractNo
    // this.servOfficeCode = this.$store.state.servOfficeCode
    // this.workDayBook = (this.$store.state.workDayBook ? this.$store.state.workDayBook : 1)
    // await this.getOffices()
    // // automatically select office on mount
    // for(let i = 0; i < this.officeOptions.length; i++){
    //   if(this.officeOptions[i].servOfficeCode == this.servOfficeCode){
    //     this.selectedOffice = this.officeOptions[i]
    //     this.onClickOffice(this.officeOptions[i])
    //     break
    //   }
    // }
  }
}
</script>
